import { t } from '@ankr.com/common';
import { useCallback } from 'react';

import { NotificationActions } from 'domains/notifications/store/NotificationActions';
import {
  setIsTFADialogOpened,
  setIsTFAEndpointRefetching,
  setTFAError,
  setTOTP,
} from 'modules/tfa/store/tfaSlice';
import { useAppDispatch } from 'store/useAppDispatch';
import { useAuth } from 'modules/auth/hooks/useAuth';
import { useTFA } from 'modules/tfa/hooks/useTFA';
import { useTFAStatusQuery } from 'modules/tfa/actions/hooks/useTFAStatusQuery';

export const useTFADialog = () => {
  const dispatch = useAppDispatch();
  const { isLoggedIn } = useAuth();

  useTFAStatusQuery({ skipFetching: !isLoggedIn });

  const { isTFADialogOpened, isTFAEnabled, isTFAEndpointRefetching, tfaError } =
    useTFA();

  const handleSetTOTP = useCallback(
    (totp: string) => dispatch(setTOTP(totp)),
    [dispatch],
  );

  const handleResetTFAError = useCallback(
    () => dispatch(setTFAError(undefined)),
    [dispatch],
  );

  const handleClose = useCallback(() => {
    dispatch(setIsTFADialogOpened(false));
    dispatch(setIsTFAEndpointRefetching(false));
    dispatch(setTOTP(undefined));
    handleResetTFAError();

    dispatch(
      NotificationActions.showNotification({
        message: t('error.two-fa'),
        severity: 'error',
      }),
    );
  }, [dispatch, handleResetTFAError]);

  const isOpened = isTFAEnabled && isTFADialogOpened;

  return {
    handleClose,
    handleResetTFAError,
    handleSetTOTP,
    isOpened,
    isTFAEndpointRefetching,
    tfaError,
  };
};
